mod.modules.define("SymbolSearchBase", "InputSearchBase", function(fn) {

	var recentQueryName = "_recent_";
	var recentListId = null;
	var rowLimit;

	fn.prototype.init = function(params) {
		this.base("init", params);

		recentListId = params.recentListId;
		this.useSearchUrl = params.useSearchUrl;
		rowLimit = params.rowLimit;		

		this.initAutocomplete();
		var self = this;

		$("div.mod-header-search").on("click", "input.symbol-search-submit", function () {
			return self.triggerDefaultSymbol();
		});
	};

	fn.prototype.initAutocomplete = function() {
		var self = this;

		this.el.modAutocomplete({
			source: function(request, response) {
				this.query = request.term;

				$.ajax({
					// modify this URL logic once VL-1564 is completed -- the below fix is temporary
					url: ("~/api/symbolsearch").resolveUrl().includes("localhost") ? ("~/api/symbolsearch").resolveUrl() : ("~/api/symbolsearch").resolveUrl().replace("http", "https"),
					dataType: "jsonp",
					data: {
						query: request.term
					},
					complete: function() {
						self.el.removeClass("loading");
					},
					success: function(data) {
						// See if this was a new request
						if (data && request.term != recentQueryName) {
							// Tell everyone that we searched for a symbol
							mod.observer.trigger("search - symbol", request.term, self.reloadDequeue);
						}

						var responseContainer = $.map(data, function(item) {
							if (item && item.Ticker != null) {
								return {
									label: item.Name + " (" + item.Ticker + ")",
									value: item.Ticker,
									wsodIssue: item.IssueId
								};
							}
						});

						//if (data.length > 0 && request.term == recentQueryName) {
						//	responseContainer.push({
						//		label: "View full list &raquo;",
						//		value: "View full list",
						//		option: recentQueryName
						//	});
						//}

						response(responseContainer);
					}
				});
			},
			minLength: 1,
			renderAsLink: self.useSearchUrl
		});

		// Add the complete menu
		this.el.modAutocomplete("option", "appendTo", this.el.parent());
		this.el.modAutocomplete("option", "position", {
			my: "left top",
			at: "left bottom",
			collision: "none",
			of: this.el,
			offset: "0 -4"
		});
	};

	fn.prototype.events = {
		"this": {
			"click": function (e, $el) {
				if ($el == undefined) {
					$el = $(e.target);
				}
				if ($el.val()) {
					// Show the last results
					this.el.modAutocomplete("widget").show();
				}
				else {
					// Show recent symbols if we're not searching
					this.el.modAutocomplete("search", recentQueryName);
				}
			},
			"keypress": function (e, $el) {				
				if ($el == undefined) {
					$el = $(e.target);
				}
				if (!$el.hasClass("loading")) {
					$el.addClass("loading");					
				}
				
				// if they hit "enter"
				if (e.which == 13 || e.keyCode == 13) {
					return this.triggerDefaultSymbol($el);
					
				} else {
					$("ul.ui-autocomplete").empty();
				}
				
			}
		}		
	};

	fn.prototype.triggerDefaultSymbol = function ($el) {
		
		// check to see if there are any symbols returned from symbol search
		var jItems = $("ul.ui-autocomplete li.ui-menu-item a");

		// if so, automatically click the first one
		if (jItems && jItems.length > 0) {
			if ($el !== undefined) {
				if ($el.hasClass("loading")) {
					$el.removeClass("loading");
				}
			}
			
			$(jItems[0])[0].click();

			// don't execute the normal form action here.
			return false;
		} else {
			return true;
		}
	}

	$.widget("custom.modAutocomplete", $.ui.autocomplete, {
		_renderMenu: function(ul, items) {
			var self = this,
				prepend = [],
				append = [];

			//prepend.push("<li class=\"spacer\"></li>");

			if (items.length === 0) {
				append.push("<li class=\"ui-autocomplete-category\">No matches found</li>");
			} else {
				$.each(items, function (index, item) {					
					if (typeof rowLimit != "undefined") {						
						if (index < rowLimit) {
							self._renderItem(ul, item);
						}
					} else {
						self._renderItem(ul, item);
					}
				});

				ul.find("li:first").addClass("first");

				if (this.query == recentQueryName) {
					prepend.push("<li class=\"ui-autocomplete-category\">Recently Viewed</li>");
				}
			}

			ul.prepend(prepend.join("")).append(append.join(""));
		},

		__response: function(content) {
			//set this up so it will display "no matches" but only if it wasn't a _recent_ search
			if (this.options.disabled || (this.query == recentQueryName && (!content || content && content.length == 0))) {
				this.close();
			} else {
				content = this._normalize(content);
				this._suggest(content);
				this._trigger("open");
			}
		},

		_renderItem: function(ul, item) {

			var li = $("<li />");
			var anchor = null;

			if (item.option == recentQueryName) {
				li.addClass("morelink");
				anchor = $("<a href='javascript:;' data-auto-list=\"" + item.option + "\"></a>");
			}
			else {

				var baseUrl = $('#quoteSearch').attr('baseUrl') || "/research";

				if (this.options.renderAsLink) {
					var hash = "#sec=company&sym=" + item.value;
					var url = ("~" + baseUrl + "?hash=" + encodeURIComponent(hash)).resolveUrl();
				} else {
					url = "javascript:;";
				}

				url = url.replace("/secure/secure","/secure");

				var anchorHTML = "<a href='" + url + "' data-auto-list='" + recentListId + "' data-auto-symbol=\"" + item.value + "\" data-issue=\"" + item.wsodIssue + "\"></a>";
				anchor = $(anchorHTML);
			}

			li.data("ui-autocomplete-item", item)
				.append(anchor.html(item.label))
				.appendTo(ul);

			return li;
		}
	});
});
